import getConfig from 'next/config';
import { btoau } from 'b2a';

const bog = require('bog');

const COLON = ':';
const ZENDESK = 'zendesk.com';

const {
  publicRuntimeConfig: {
    altHostNames,
    loginUrl,
    registerUrl,
  },
} = getConfig();

// DEFAULT_HOST will be used in localhost only
const DEFAULT_HOST = 'www.binance.com';

const getHostNameWithPort = (req) => req ? req.get('host') :
  (typeof window !== 'undefined' && window.location.host) || DEFAULT_HOST;

export const getHostName = (req) => {
  const hostNameWithPort = getHostNameWithPort(req);
  return hostNameWithPort.indexOf(COLON) === -1 ?
    hostNameWithPort : hostNameWithPort.split(COLON)[0];
};

export const shouldUseAltUrl = req => {
  const hostname = getHostName(req);
  return !!altHostNames.find((host) => hostname.endsWith(host));
};

export const shouldUseAltWssUrl = req => shouldUseAltUrl(req);

export const getUrlParam = (key) => {
  if (typeof window !== 'undefined') {
    const search = window.location.search.substr(1);
    const params = search.split('&');
    for (let i = 0; i < params.length; i++) {
      const keyValueArray = params[i].split('=');
      if (key === keyValueArray[0]) {
        return keyValueArray[1];
      }
    }
  }
  return null;
};

// export const getLoginUrl = (locale = 'en', callbackUrl = '') => `${LOGIN_URL.replace('%locale', locale)}${callbackUrl && `?callback=${callbackUrl}`}`;
export const getLoginUrl = (locale = 'en', callbackUrl = '') => {
  const url = loginUrl.replace('%locale', locale);
  try {
    if (!callbackUrl) {
      callbackUrl = window.location.href;
    }
  } catch (e) {
    bog.info(e);
  }
  return `${url}?return_to=${btoau(callbackUrl)}`;
};

export const getRegisterUrl = (locale = 'en', callbackUrl = '') => {
  const url = registerUrl.replace('%locale', locale);
  try {
    if (!callbackUrl) {
      callbackUrl = window.location.href;
    }
  } catch (e) {
    bog.info(e);
  }
  return `${url}?return_to=${btoau(callbackUrl)}`;
};

// relative url cannot start with  // or /\ or \\ etc. as this will allow open redirect in javascript
// Example: //google.com
const relativePathRegx = new RegExp('^/$|^(/[\\w.?&=-]+[/\\w.?&=-]*)$');

// relative path
const checkRelative = (url) => relativePathRegx.test(url);

const checkAbsolute = (url) => {
  const whiteList = [
    'binance.com',
    'binance.net',
    'binance.co',
    'binance.vision',
    'binance.sg',
    'binance.co.ug',
    'binance.charity',
    'binance.zendesk.com',
    'binancesingapore.zendesk.com',
    'binanceuganda.zendesk.com',
  ];
  try {
    const callback = new URL(url);
    if (url.includes(ZENDESK)) {
      return !!whiteList.find(w => `${callback.protocol}//${w}` === callback.origin);
    }
    return !!whiteList.find(w => callback.origin.endsWith(`.${w}`));
  } catch (_) {
    return false;
  }
};

export const checkCallback = (url) => {
  /* to prevent payloads such as
  https://www.binance.com()@google.com
  https://google.com%5www.binance.com
  */
  if (url.includes('@') || url.includes('\\')) {
    return false;
  }

  // treat all url that do not start with http as relative url
  if (!url.startsWith('http')) {
    return checkRelative(url);
  }
  return checkAbsolute(url);
};

export const pushLoginPage = (locale = 'en', callbackUrl = '') => {
  window.location.href = getLoginUrl(locale, callbackUrl);
};

export const pushRegisterPage = (locale = 'en', callbackUrl = '') => {
  window.location.href = getRegisterUrl(locale, callbackUrl);
};
